import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import TabBar from '../tab-bar/tab-bar'

import style from './view-switch.module.css'

const noop = Function.prototype

const propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    className: PropTypes.string,
    onTabClick: PropTypes.func,
    selectedTabId: PropTypes.string,
    tabHighlightingProperty: PropTypes.string,
    tabIdProperty: PropTypes.string
}

const defaultProps = {
    onTabClick: noop,
    tabHighlightingProperty: 'isHighlighted',
    tabIdProperty: 'id'
}

/**
 * This is a view switch which contains only the tabs (not also the corresponding tab content).
 * These tabs shall be given as children to the view switch. The only task of a tab children is its rendering.
 *
 * A tab has to define an ID property and a highlighting property.
 * - the ID property can be of any type and is used as a reference to a tab.
 * - the highlighting property is of boolean type. A value of 'true' means that the tab is selected and therefore
 * it should be render itself in an other way as in the normal rendering.
 *
 * The selection of a tab is handled by the view switch bar. If a selection occurrs a given callback function will
 * be called (with the selected tab ID as argument).
 *
 * @param {Object} props - The current component properties
 * @param {Array|ReactElement|string} [props.children] - Array of React elements (might be empty)
 * @param {string} [props.className] - CSS class name for additional styling
 * @param {Function} [props.onTabClick=noop] - Callback function when tab get's clicked
 * @param {string} [props.selectedTabId] - The ID of the selected tab (icon)
 * @param {string} [props.tabIdProperty='id'] - Name of the ID property
 * @param {string} [props.tabHighlightingProperty='isHighlighted'] - Name of the highlighting property
 *
 * @example
 * <code>
 * <ViewSwitch onTabClick={(id) => console.log(id)}>
 *    <ViewSwitchTab key='blue' id='first'>
 *        <TableIcon />
 *    </ViewSwitchTab>
 * </ViewSwitch>
 * </code>
 */
function ViewSwitch(props) {
    const { children, className, onTabClick, selectedTabId, tabHighlightingProperty, tabIdProperty } = props

    return (
        <div className={cx(style['view-switch'], className, 't3sel-view-switch')}>
            <TabBar
                className={style['view-switch-tab-bar']}
                {...{
                    onTabClick,
                    selectedTabId,
                    tabHighlightingProperty,
                    tabIdProperty
                }}
            >
                {children}
            </TabBar>
        </div>
    )
}

ViewSwitch.propTypes = propTypes
ViewSwitch.defaultProps = defaultProps

export default ViewSwitch
